import styles from './Dashboard.module.css';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Space } from 'antd';
import BookingCalendarModal from './BookingCalendar/BookingCalenderModal';
import { logout } from '../auth';
import { getUserName } from '../utils/getUserName';
import AvailModel from '../FrontComponent/AvailModel';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Header = ({ showCreateBookingBtn, hotelId }) => {
  const navigate = useNavigate();

  /* const handleMenuClick = ({ key }) => {
    if (key === '1') {
      logout();
    }
  }; */

  const handleMenuClick = ({ key }) => {
    if (key === '1') {
      toast.info('Signing out...', {
        autoClose: 1000,
        onClose: logout(),
      });
    }
  };

  const items = [
    {
      key: '1',
      label: <span>Sign out</span>,
    },
  ];

  const getCurrentDate = () => {
    const today = new Date();
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return today.toLocaleDateString('en-US', options);
  };

  const DateBar = () => (
    <div className={styles.dateBar}>
      <span className={styles.currentDate}>{getCurrentDate()}</span>
      {/* {showCreateBookingBtn && (
        <button className={styles.createBookingButton} onClick={openModal}>
          Create booking
        </button>
      )} */}
      {showCreateBookingBtn && <AvailModel hotelId={hotelId} />}
    </div>
  );

  return (
    <header className={styles.headerContainer}>
      <div className={styles.header}>
        <div className={styles.searchBarContainer}>
          {/* Search bar can be added here */}
        </div>

        <div className={styles.headerActions}>
          <BookingCalendarModal />
          <Dropdown
            menu={{ items, onClick: handleMenuClick }}
            placement="bottomRight"
          >
            <div style={{ cursor: 'pointer' }}>
              <Space>
                <img
                  src="../images/user.avif"
                  alt="User profile"
                  className={styles.userAvatar}
                />
                <span className={styles.profileUsername}>{getUserName()}</span>
              </Space>
            </div>
          </Dropdown>
        </div>
      </div>

      <DateBar />
    </header>
  );
};
